export function makeAssignmentNumberValidation<T>(errorMsg: T) {
  // eslint-disable-next-line
  const re = /^[А-Я]{2}(-[А-Я])[0-9]{1,100}(-[0-9]{1,5})((пр)*)((кв)*)((кс)*)$/;

  return (assignmentNumber: string) => (re.test(String(assignmentNumber)) ? undefined : errorMsg);
}
